import {useEffect, useState} from "react"

const useContent = (props) =>{

    const [englishData, setEnglishData] = useState(null);


    useEffect(() => {
        const fetchData = async () => {
          try {
            const path = process.env.REACT_APP_CDN;
            const data = await fetch(`${path}wholesale-websites-pr/jsons/${props}.json`);
            const jsonData = await data.json();
            setEnglishData(jsonData);
          } catch (error) {
            console.log("Error fetching Data", error);
          }
        };
        fetchData(); 
      }, [props]);
    
      return englishData;
    };

export default useContent;